/**
 * @generated SignedSource<<987867774544e4f15c78f3627b3a8203>>
 * @relayHash ced2fc19e942c004393c066bef43384d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2d8511617c2ae739deca629af208d0c0aff791868ae7f06fd41f3bca8189b104

import type { ConcreteRequest } from 'relay-runtime';
export type workspaceThemeManagementSetWorkspaceThemePreferenceMutation$variables = {
  accountId: string;
  theme: string;
  workspaceAri: string;
};
export type workspaceThemeManagementSetWorkspaceThemePreferenceMutation$data = {
  readonly settings_updateUserPreferencesWorkspace: {
    readonly theme: string | null;
  } | null;
};
export type workspaceThemeManagementSetWorkspaceThemePreferenceMutation = {
  response: workspaceThemeManagementSetWorkspaceThemePreferenceMutation$data;
  variables: workspaceThemeManagementSetWorkspaceThemePreferenceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "theme"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "theme",
        "variableName": "theme"
      },
      {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
      }
    ],
    "concreteType": "SettingsUserPreferences",
    "kind": "LinkedField",
    "name": "settings_updateUserPreferencesWorkspace",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "theme"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "2d8511617c2ae739deca629af208d0c0aff791868ae7f06fd41f3bca8189b104",
    "metadata": {},
    "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a59aa9b6da224d8962255852220e8493";

export default node;
